import { timesToOptions } from "src/shared/utils/react-select";

import { formatTime, getDaysTillEvent } from "./utils";

const possibleDates = getDaysTillEvent();
export const TIME_OPTIONS = timesToOptions(formatTime, possibleDates);
